module.exports = __webpack_public_path__ + "media/images/iconDelete__inactive-d4f3a7af499df2c99927cfafe0a13de3.png";